module.exports = __webpack_public_path__ + "img/cetae-logo.92e5ddf2.png";